import { createTheme } from '@mui/material/styles';

const headingFont = '"Outfit", "Roboto", "Helvetica", "Arial", sans-serif';
const bodyFont = '"Roboto", "Helvetica", "Arial", sans-serif';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#171c8f',
      light: '#2a30a3',
      dark: '#0f1370',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f1c400',
      light: '#ffd54a',
      dark: '#c9a000',
      contrastText: '#0a0a0a',
    },
    background: {
      default: '#f4f6fc',
      paper: '#ffffff',
    },
    text: {
      primary: '#12151c',
      secondary: '#5c6578',
    },
    success: {
      main: '#1e8a4a',
    },
    warning: {
      main: '#f1c400',
    },
    error: {
      main: '#dc3545',
    },
    info: {
      main: '#171c8f',
    },
  },
  typography: {
    fontFamily: bodyFont,
    h1: {
      fontFamily: headingFont,
      fontWeight: 800,
      fontSize: 'clamp(2.25rem, 5vw, 3.5rem)',
      lineHeight: 1.08,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: headingFont,
      fontWeight: 700,
      fontSize: 'clamp(1.85rem, 3.5vw, 2.65rem)',
      lineHeight: 1.12,
      letterSpacing: '-0.015em',
    },
    h3: {
      fontFamily: headingFont,
      fontWeight: 700,
      fontSize: 'clamp(1.5rem, 2.8vw, 2rem)',
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: headingFont,
      fontWeight: 600,
      fontSize: '1.35rem',
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: headingFont,
      fontWeight: 600,
      fontSize: '1.15rem',
      lineHeight: 1.35,
    },
    h6: {
      fontFamily: headingFont,
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1.0625rem',
      lineHeight: 1.65,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.55,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.02em',
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          padding: '12px 28px',
          fontWeight: 600,
        },
        contained: {
          boxShadow: '0 8px 24px rgba(23, 28, 143, 0.25)',
          '&:hover': {
            boxShadow: '0 12px 32px rgba(23, 28, 143, 0.32)',
          },
        },
        containedSecondary: {
          boxShadow: '0 8px 28px rgba(241, 196, 0, 0.45)',
          '&:hover': {
            boxShadow: '0 12px 36px rgba(241, 196, 0, 0.55)',
          },
        },
        outlined: {
          borderWidth: 2,
        },
        sizeLarge: {
          padding: '14px 32px',
          fontSize: '1.05rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 24px rgba(15, 19, 112, 0.07)',
          border: '1px solid rgba(23, 28, 143, 0.06)',
          transition: 'box-shadow 0.25s ease, transform 0.25s ease, border-color 0.25s ease',
          '&:hover': {
            boxShadow: '0 20px 48px rgba(15, 19, 112, 0.12)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          letterSpacing: '0.04em',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: '0 4px 20px rgba(15, 19, 112, 0.06)',
          border: '1px solid rgba(23, 28, 143, 0.08)',
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: 0,
          },
        },
      },
    },
  },
});
